import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';

// Components
import Login from './components/Auth/Login';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import UserManagement from './components/Users/UserManagement';
import UserStatsPage from './components/Users/UserStatsPage';
import GroupManagement from './components/Groups/GroupManagement';
import GroupDetailsPage from './components/Groups/GroupDetailsPage';
import ActivitiesMonitoring from './components/Activities/ActivitiesMonitoring';
import ChallengesGoals from './components/Challenges/ChallengesGoals';
import ProgressView from './components/Challenges/ProgressView';
import HotstepperCommunication from './components/Hotstepper/HotstepperCommunication';
import CityLeaderboard from './components/Leaderboard/CityLeaderboard';
import InactiveUsers from './components/Users/InactiveUsers';
import ReportsAnalytics from './components/Reports/ReportsAnalytics';

// API Configuration - Alternative without spaces
// axios.defaults.baseURL = 'http://localhost/run-dashboard-scratch/api';

// Current configuration with spaces
// axios.defaults.baseURL = 'http://localhost/run_dashboard_scratch/api';
axios.defaults.baseURL = 'https://admin.stepping4life.org//api';
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Auth Context
export const AuthContext = React.createContext();

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth token
    const token = localStorage.getItem('adminToken');
    const userData = localStorage.getItem('adminUser');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminUser', JSON.stringify(userData));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    delete axios.defaults.headers.common['Authorization'];
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <Router>
        <div className="App">
          {!user ? (
            <Login />
          ) : (
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/users" element={<UserManagement />} />
                <Route path="/users/:userId/stats" element={<UserStatsPage />} />
                <Route path="/users/inactive" element={<InactiveUsers />} />
                <Route path="/groups" element={<GroupManagement />} />
                <Route path="/groups/:groupId/details" element={<GroupDetailsPage />} />
                <Route path="/activities" element={<ActivitiesMonitoring />} />
                <Route path="/challenges" element={<ChallengesGoals />} />
                <Route path="/challenges/:type/:id/progress" element={<ProgressView />} />
                <Route path="/hotstepper" element={<HotstepperCommunication />} />
                <Route path="/leaderboard" element={<CityLeaderboard />} />
                <Route path="/reports" element={<ReportsAnalytics />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Layout>
          )}
        </div>
      </Router>
    </AuthContext.Provider>
  );
}

export default App; 